export default "__VITE_PUBLIC_ASSET__1cf672ad__"